import React from 'react';

const GenerateStatus = ({ data }) => {
    let cellStyle = {
        padding: "5px",
        color: "black",
    };

    if (data) {
        switch (data) {
            case "Đang gửi":
                cellStyle.color = "#3caa62";
                break;
            case "Thất bại":
                cellStyle.color = "red";
                break;
            case "Thành công":
                cellStyle.color = "green";
                break;
            case "Từ chối":
                cellStyle.color = "red";
                break;
            case "Đã phê duyệt":
                cellStyle.color = "blue";
                break;
            case "Đang gửi":
                cellStyle.color = "orange";
                break;
            case "Hoàn thành":
                cellStyle.color = "#18DF32";
                break;
            default:
                break;
        }
    }

    return (
        <div style={cellStyle}>
            {data ? data : ""}
        </div>
    );
};

export default GenerateStatus;
